import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "color", "height", "label", "onDarkBg", "path", "size", "width"];
import React from 'react';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';
import SvgPath from './_svg_path';
/**
 * _Icons are effective in visually communicating the essential parts of the service. They are rather small in size and support text information in actions, controls and feedback etc._
 *
 * ***
 *
 * See
 * [Icon Catalog from the Visual Guidelines](https://op.design/system/visual-guidelines/icons)
 * to find out which icons are included in which package. The component name
 * format is `<Icon{name}/>` (see examples).
 *
 * By default icons are hidden from screen readers. For semantic icons set an
 * appropriate `label` for the icon. That sets the `aria-label` of the HTML element,
 * which is the alternative text for screen readers.
 *
 * For icons used on dark backgrounds `onDarkBg` must be set to ensure
 * their visibility and accessible color contrasts.
 *
 */
export const Icon = _ref => {
  let {
      className,
      color = 'default',
      height = 32,
      label,
      onDarkBg = false,
      path,
      size = 'default',
      width = 32
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const prefix = 'ds-icon';
  const cn = buildVersionedClassNames(prefix, className, {
    [prefix + "--" + size]: size !== 'default',
    [prefix + "--" + color]: color !== 'default',
    [prefix + "--inverse"]: onDarkBg
  });
  return /*#__PURE__*/React.createElement(SvgPath, _extends({
    className: cn,
    height: height,
    label: label,
    path: path != null ? path : '',
    width: width
  }, props));
};
export default Icon;